'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var registerCSSInterfaceWithDefaultTheme = {};

exports.__exports = registerCSSInterfaceWithDefaultTheme;
